export const newTrack = (): RecordedTrack => ({
  instrument: 'Default instrument',
  notes: [],
  isRecording: false,
  isLoop: false,
  start: 0,
  end: 0,
})